import { BlogPost } from '../types';

export const samplePosts: BlogPost[] = [
  {
    id: 'launch',
    title: 'Introducing LinguaTracker: Your Personal Vocabulary Assistant',
    content: `
# Introducing LinguaTracker: Your Personal Vocabulary Assistant

We're thrilled to announce the launch of LinguaTracker, a sophisticated vocabulary learning platform designed to transform how you expand and master your vocabulary. Let's explore what makes LinguaTracker special and what's on the horizon.

## Current Features

### Core Functionality
- **Smart Word Management**: Add, organize, and track your vocabulary with detailed definitions
- **Multi-Source Dictionary Integration**: Comprehensive definitions from multiple reliable sources
- **Dark/Light Theme**: Comfortable reading experience in any lighting condition
- **Intelligent Import System**: Import words from TXT, CSV, and PDF files with automatic definition fetching
- **Progress Analytics**: Visual tracking of your vocabulary growth and mastery levels

### Learning Tools
- **Advanced Study Mode**: Interactive flashcard system with spaced repetition
- **Mastery Tracking**: Monitor your progress with detailed statistics
- **Categories & Tags**: Organize words by custom categories
- **Blog Integration**: AI-powered blog posts about vocabulary and language learning

### Technical Features
- **Offline Support**: Full functionality even without internet connection
- **Local Database**: Secure storage of your vocabulary and progress
- **Export Capabilities**: Share and backup your word collections
- **Responsive Design**: Seamless experience across all devices



### Enhanced Learning Features
- Multiple accent pronunciation audio
- Contextual example sentences
- Expanded word relationships (synonyms, antonyms)
- Visual learning aids
- Cultural context notes

### Advanced Study Tools
- Additional study modes (quizzes, writing exercises)
- Daily learning goals and streaks
- Practice exercises with real-world context
- Personalized learning paths

### Social Features
- User profiles and authentication
- Collaborative learning groups
- Word list sharing
- Discussion forums

### AI Enhancements
- Smart word recommendations
- Automated quiz generation
- Content difficulty analysis
- Personalized learning suggestions

### Gamification
- Achievement system
- Leaderboards
- Points and rewards
- Daily challenges

### Technical Improvements
- Cloud synchronization
- Mobile app version
- Browser extension
- Additional export formats (Anki, PDF)

### Accessibility
- Screen reader optimization
- Keyboard shortcuts
- High contrast mode
- Font size customization

## Get Started

LinguaTracker is available now, completely free to use. Start building your vocabulary today and stay tuned for regular updates as we roll out new features.

## Feedback

We value your input! Share your experience and suggestions to help shape the future of LinguaTracker.

*Prompted with ❤️ in San Francisco by Alexander Orchi*
    `,
    excerpt: "Introducing LinguaTracker, a sophisticated vocabulary learning platform with smart features, study tools, and exciting upcoming enhancements. Start expanding your vocabulary today!",
    author: 'Alexander Orchi',
    date: new Date().toISOString(),
    imageUrl: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8',
    tags: ['Announcement', 'Features', 'Learning'],
    relatedWords: [],
    likes: 0,
    comments: []
  }
];